import React from 'react';
import { MainView, NoAccessView } from '@repo/ui/Views';
import AutoRespondersTable from '../components/AutoRespondersTable';
import { useAccount } from '@/hooks/useAccount';

import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';

const AutoResponders = () => {
  const account = useAccount();
  const accountId = account.id;

  const user = useUser();

  return POLICIES['messaging_auto_responses:index'](user) ? (
    <MainView title="Account number auto responders">
      {/* {!accountId ? (
        <p>No account id provided</p>
      ) : (
        <AutoResponderCrudForm
          crud={AccountDefaultAutoResponderCRUD}
          id={String(accountId)}
          canDelete={POLICIES['messaging_auto_responses:update'](user)}
          canUpdate={POLICIES['messaging_auto_responses:update'](user)}
        />
      )}
      <div className="my-12 h-[1px] bg-grey-400"></div>
      <h2 className="mb-6 text-2xl font-bold sm:text-4xl dark:text-blue-100">
        Account number auto responders
      </h2> */}
      {!accountId ? (
        <p>No account id provided</p>
      ) : (
        <AutoRespondersTable accountId={Array.isArray(accountId) ? accountId[0] : accountId} />
      )}
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default AutoResponders;
